import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getConsumerPhoneTypes = createAsyncThunk(
  '/getConsumerPhoneTypes',
  async () => {
    const response = await axios.get('/GetConsumerPhoneTypes');
    return response.data;
  }
);

export const getConsumerPhoneTypeDetails = createAsyncThunk(
  '/getConsumerPhoneTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetConsumerPhoneTypeDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const consumerPhoneTypeSlice = createSlice({
  name: 'consumerPhoneType',
  initialState: {
    loading: false,
    error: '',
    consumerPhoneTypes: [],
    consumerPhoneTypeDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.consumerPhoneTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },
  extraReducers: {
    [getConsumerPhoneTypes.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerPhoneTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerPhoneTypes.fulfilled]: (state, action) => {
      state.consumerPhoneTypes = action.payload;
      state.loading = false;
    },
    [getConsumerPhoneTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerPhoneTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerPhoneTypeDetails.fulfilled]: (state, action) => {
      state.consumerPhoneTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.consumerPhoneTypeDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const consumerPhoneTypeActions = consumerPhoneTypeSlice.actions;

export default consumerPhoneTypeSlice;
